/**
 * Lets the bootstrap in index.tsx fire the `/auth/me` request
 * at the same time as the tenant and translation requests,
 * instead of waiting for the Redux store to be created. The
 * auth initializer then consumes the in-flight promise.
 */
let pending: Promise<any> | null = null;

export const AuthBootstrap = {
  start(fetchMe: () => Promise<any>): Promise<any> {
    pending = fetchMe();
    return pending;
  },

  /**
   * Returns the started promise once, or null when nothing was
   * started (or it was already consumed).
   */
  consume(): Promise<any> | null {
    const promise = pending;
    pending = null;
    return promise;
  },
};
